'use client';

const Chip = ({ children, className = '' }) => (
  <span
    className={`h-[20px] px-[6px] flex items-center rounded-[2px] font-satoshi text-[11px] leading-[14px] ${className}`}
  >
    {children}
  </span>
);

export default Chip;
